import { useDispatch, useSelector } from "react-redux"
import { Dialog } from "../Dialog"
import { RdxType } from "../../../biz/data/Types";
import { BaseDialogOptionsType, BaseDialogType, BaseToastType, CHANGE_UI_DIALOGS, CHANGE_UI_TOASTS } from "../../../biz/data/redux/uIReducer";
import { PortalContainer } from "../main/Portal";
import { Padder } from "./SimpleElements";
import { useEffect, useState } from "react";

export const useDialogs = () => {
    const dialogs = useSelector((state: RdxType) => state.ui.dialogs);
    const toasts = useSelector((state: RdxType) => state.ui.toasts);
    const dispatch = useDispatch();

    return {
        dialogs: dialogs,
        toasts: toasts,
        showWarning: (header: string, text: string) => {
            const d: BaseDialogType = {
                header: header, text: text,
                type: "warning", visible: true
            };
            dispatch({ type: CHANGE_UI_DIALOGS, payload: d });
        },
        showInfo: (header: string, text: string, options?: BaseDialogOptionsType) => {
            const d: BaseDialogType = {
                ...options,
                header: header, text: text,
                type: "info", visible: true
            };
            dispatch({ type: CHANGE_UI_DIALOGS, payload: d });
        },
        showConfirm: (header: string, text: string, onOk: () => void, onCancel?: () => void, okText?: string, cancelText?: string) => {
            const d: BaseDialogType = {
                header: header, text: text,
                onOk: onOk, onCancel: onCancel,
                okText: okText, cancelText: cancelText,
                type: "confirm", visible: true,
            };
            dispatch({ type: CHANGE_UI_DIALOGS, payload: d });
        },
        showProActivated: () => {
            const d: BaseDialogType = {
                ...dialogs,
                header: "", text: "Oh!Pro har aktiverats!",
                type: "proactivated", visible: true
            };
            dispatch({ type: CHANGE_UI_DIALOGS, payload: d });
        },

        dismissdialog: () => {
            dispatch({ type: CHANGE_UI_DIALOGS, payload: undefined });
        },
        onOk: () => {
            if (!!dialogs?.onOk) {
                dialogs.onOk()
            }
            dispatch({ type: CHANGE_UI_DIALOGS, payload: undefined });
        },
        onCancel: async () => {
            if (!!dialogs?.onCancel) {
                await dialogs.onCancel()
            }
            dispatch({ type: CHANGE_UI_DIALOGS, payload: undefined });
        },
        showToast: (e: string) => {
            const p: BaseToastType = { text: e };
            dispatch({ type: CHANGE_UI_TOASTS, payload: p });
        },
        clearToast: () => {
            dispatch({ type: CHANGE_UI_TOASTS, payload: undefined });
        }
    }
}

export const GenericDialog = () => {
    const d = useDialogs();

    if (d?.dialogs?.type === "proactivated") {
        return (<ProIsActiveDialog visible={d.dialogs?.visible ?? false} onDismiss={d.dismissdialog} />)
    }

    return (
        <Dialog
            type={d?.dialogs?.type}
            header={d.dialogs?.header}
            visible={d.dialogs?.visible ?? false}
            onCancel={d?.dialogs?.type === "confirm" ? d.onCancel : undefined}
            onOk={d?.dialogs?.type === "confirm" ? d.onOk : undefined}
            okText={d.dialogs?.okText}
            okIcon={d.dialogs?.okIcon}
            cancelText={d.dialogs?.cancelText}
            clickOutside={d.dismissdialog}
        >
            {d.dialogs?.text}
        </Dialog>
    )
}
export const OkDialog = ({ visible, header, onOk, okButtonText }: { visible: boolean, header: string, onOk(): void, okButtonText: string }) => {
    return (
        <Dialog
            visible={visible}
            header={header}
            onOk={onOk}
            okText={okButtonText}
        >
            <div>
                alsdlkadjlskdj laksdj laskdj asldk jadlk jaslk
            </div>
        </Dialog>
    )
}
export const ProIsActiveDialog = ({ visible, onDismiss }: { visible: boolean, onDismiss(): void }) => {
    return (
        <PortalContainer visible={visible} containerClass="xxxx-get-pro-dialog" clickOutside={onDismiss}>
            <div className="pro-is-active-message">
                <div>
                    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.5 7C15.8125 7 11.5625 9.5 9.1875 13.5C6.875 17.5625 6.875 22.5 9.1875 26.5C11.5625 30.5625 15.8125 33 20.5 33C25.125 33 29.375 30.5625 31.75 26.5C34.0625 22.5 34.0625 17.5625 31.75 13.5C29.375 9.5 25.125 7 20.5 7ZM20.5 36C14.75 36 9.5 33 6.625 28C3.75 23.0625 3.75 17 6.625 12C9.5 7.0625 14.75 4 20.5 4C26.1875 4 31.4375 7.0625 34.3125 12C37.1875 17 37.1875 23.0625 34.3125 28C31.4375 33 26.1875 36 20.5 36ZM27.5625 17.0625L19.5625 25.0625C18.9375 25.6875 18 25.6875 17.4375 25.0625L13.4375 21.0625C12.8125 20.5 12.8125 19.5625 13.4375 19C14 18.375 14.9375 18.375 15.5625 19L18.5 21.9375L25.4375 15C26 14.375 26.9375 14.375 27.5625 15C28.125 15.5625 28.125 16.5 27.5625 17.0625Z" fill="#9F8E73" />
                    </svg>
                </div>
                <Padder heightPx={16} />
                <div>
                    Oh!Pro har aktiverats!
                </div>
            </div>
        </PortalContainer>
    )

}
export const GenericToast = () => {

    const d = useDialogs();

    const visible = !!d?.toasts;
    const [removing, setRemoving] = useState<boolean>(false);

    useEffect(() => {
        if (visible === true) {
            setTimeout(() => { setRemoving(true) }, 1100)
            setTimeout(() => {
                d.clearToast();
                setRemoving(false);
            }, 1500);
        }
    }, [, visible])


    return (
        <PortalContainer containerClass={"toast-outer" + (removing ? " removing" : "")} visible={visible} clickOutside={() => { }}>
            <div className={"toast" + (visible ? " visible" : "")}>
                <div className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <path d="M20 7C15.3125 7 11.0625 9.5 8.6875 13.5C6.375 17.5625 6.375 22.5 8.6875 26.5C11.0625 30.5625 15.3125 33 20 33C24.625 33 28.875 30.5625 31.25 26.5C33.5625 22.5 33.5625 17.5625 31.25 13.5C28.875 9.5 24.625 7 20 7ZM20 36C14.25 36 9 33 6.125 28C3.25 23.0625 3.25 17 6.125 12C9 7.0625 14.25 4 20 4C25.6875 4 30.9375 7.0625 33.8125 12C36.6875 17 36.6875 23.0625 33.8125 28C30.9375 33 25.6875 36 20 36ZM27.0625 17.0625L19.0625 25.0625C18.4375 25.6875 17.5 25.6875 16.9375 25.0625L12.9375 21.0625C12.3125 20.5 12.3125 19.5625 12.9375 19C13.5 18.375 14.4375 18.375 15.0625 19L18 21.9375L24.9375 15C25.5 14.375 26.4375 14.375 27.0625 15C27.625 15.5625 27.625 16.5 27.0625 17.0625Z" fill="#9F8E73" />
                    </svg>
                </div>
                <Padder heightPx={16} />
                <div className="text">
                    {d?.toasts?.text}
                </div>
            </div>
        </PortalContainer>
    )
}